import { render, staticRenderFns } from "./SelectCoreCareUnits.vue?vue&type=template&id=d2b41e4a&"
import script from "./SelectCoreCareUnits.vue?vue&type=script&lang=js&"
export * from "./SelectCoreCareUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports